// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 0px) and (max-width: 766px) {
  /* For mobile phones: */
  .form-group {
    margin-left: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/e-form/form-generate/field-builder/field-builder.component.scss"],"names":[],"mappings":"AAAA;EACG,uBAAA;EACA;IACG,iBAAA;EACJ;AACF","sourcesContent":["@media (min-width: 0px) and (max-width: 766px) {\n   /* For mobile phones: */\n   .form-group {\n      margin-left: 10px;\n   }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
